import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { LicenseForm } from './license.form';
import { AbstractFormComponent } from '../../../../../shared/crud/component/form.component';

@Component({
  selector: 'admin-license-form',
  templateUrl: './form.component.html',
  styleUrls: [ './form.component.scss' ]
})
export class AdminLicenseFormComponent extends AbstractFormComponent implements OnInit, AfterViewInit {

  @Input() row: any;
  @Input() selectedRowId: number;
  @Output() makeDefault = new EventEmitter();
  @Output() delete = new EventEmitter();
  isEditMode: boolean = false;

  features: string[] = [ 'photo', 'print', 'greenscreen', 'facial-recognition', 'ai-removal' ];
  featuresLabels: string[] = [ 'Photo', 'Print', 'Greenscreen', 'Face search', 'AI Background Removal' ];

  constructor(formBuilder: LicenseForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute) {
    super(formBuilder, httpClient, toastrService, router, route);
  }

  ngOnInit() {
    super.ngOnInit();
    this.record = this.row;
    this.form.patchValue(this.row);
  }

  ngAfterViewInit() {
    if (this.row.id) {
      this.formMode = 'update';
      this.form.reset(this.row);
    } else {
      this.formMode = 'create';
    }
  }

  protected getUrl(forceId?: number): string {
    const params = this.route.snapshot.params;
    return '/admin/license' + (params.id ? `/${params.id}` : forceId ? `/${forceId}` : '');
  }

  protected onSubmit(response: any): void {
    this.editRow();
  }

  submit() {
    super.submit();
  }

  load(id: number) {
    this.loading = true;
    let url = this.getUrl(id);
    if (this.urlBuilder) {
      url = this.urlBuilder.buildUrl(url);
    }
    this.httpClient.get<any>(url)
      .subscribe(
        (data: any) => {
          this.row = data;
          this.form.patchValue(this.row);
          this.loading = false;
        },
        (error: any) => {
          this.toastrService.error(error.message);
          this.loading = false;
        }
      );
  }

  editRow() {
    this.isEditMode = !this.isEditMode;
  }
}
